import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withCtx as _withCtx } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "w-full flex flex-col" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "text-left font-bold text-2xl" }, "Dados de Pessoais"),
  /*#__PURE__*/_createElementVNode("p", { class: "text-left text-sm text-gray-500" }, "Preencha com seus dados pessoais.")
], -1)
const _hoisted_2 = { class: "flex flex-col w-full gap-2" }

import { storeToRefs } from 'pinia'
import DsSwitch from '@/components/designSystem/Switch/index.vue'
import { useDoctorRegistryStore } from '@/pinia-store/useDoctorRegistryStore'
import { rules } from '@/utils/rules'
import { ref } from 'vue'
import Network from '@/Network'
import { validateCPF } from '@/utils/string'


export default /*#__PURE__*/_defineComponent({
  __name: 'PersonalData',
  setup(__props) {

const doctorRegistryStore = useDoctorRegistryStore()
const { personalDataForm, personalDataFormRef } = storeToRefs(doctorRegistryStore)

const civilStates = [
  { title: 'Solteiro(a)', value: 'solteiro' },
  { title: 'Casado(a)', value: 'casado' },
  { title: 'Separado(a)', value: 'separado' },
  { title: 'Divorciado(a)', value: 'divorciado' },
  { title: 'Viúvo(a)', value: 'viuvo' },
  { title: 'União Estável', value: 'uniao_estavel' }
]

const cpfIsValid = ref<string>('')

const verifyCpf = async () => {
  if (!validateCPF(personalDataForm.value.cpf)) return
  try {
    cpfIsValid.value = ''
    const cpf = personalDataForm.value.cpf.replace(/\D/g, '')
    const [data, data2] = await Promise.all([
      Network.user.verifyCpf(personalDataForm.value.cpf),
      Network.user.verifyCpf(cpf)
    ])
    if (data.cpfIsAlreadyInUse || data2.cpfIsAlreadyInUse) {
      cpfIsValid.value = 'Este cpf já está em uso!'
    }
  } catch (error) {
    cpfIsValid.value = 'Erro ao validar cpf!'
  }
}

return (_ctx: any,_cache: any) => {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_autocomplete = _resolveComponent("v-autocomplete")!
  const _component_v_form = _resolveComponent("v-form")!
  const _directive_maska = _resolveDirective("maska")!

  return (_openBlock(), _createBlock(_component_v_form, {
    ref_key: "personalDataFormRef",
    ref: personalDataFormRef,
    class: "w-full flex gap-7 items-center flex-col rounded overflow-hidden mt-5 mb-4"
  }, {
    default: _withCtx(() => [
      _hoisted_1,
      _createElementVNode("div", _hoisted_2, [
        _createVNode(DsSwitch, {
          modelValue: _unref(personalDataForm).isForeigner,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(personalDataForm).isForeigner) = $event)),
          label: "Identificador Estrangeiro",
          size: "small",
          class: "mb-2"
        }, null, 8, ["modelValue"]),
        (!_unref(personalDataForm).isForeigner)
          ? (_openBlock(), _createBlock(_component_v_text_field, {
              key: 0,
              modelValue: _unref(personalDataForm).rg,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(personalDataForm).rg) = $event)),
              label: "* RG",
              class: "w-full",
              color: "primary20",
              variant: "outlined",
              rules: [_unref(rules).required]
            }, null, 8, ["modelValue", "rules"]))
          : (_openBlock(), _createBlock(_component_v_text_field, {
              key: 1,
              modelValue: _unref(personalDataForm).foreignRegistrationNumber,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(personalDataForm).foreignRegistrationNumber) = $event)),
              label: "* RNE / RNM",
              class: "w-full",
              color: "primary20",
              variant: "outlined",
              rules: [_unref(rules).required]
            }, null, 8, ["modelValue", "rules"])),
        _createVNode(_component_v_text_field, {
          modelValue: _unref(personalDataForm).issuingAuthority,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(personalDataForm).issuingAuthority) = $event)),
          label: "* Orgão Expeditor",
          class: "w-full",
          color: "primary20",
          variant: "outlined",
          rules: [_unref(rules).required]
        }, null, 8, ["modelValue", "rules"]),
        _withDirectives(_createVNode(_component_v_text_field, {
          modelValue: _unref(personalDataForm).issueDate,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(personalDataForm).issueDate) = $event)),
          label: "* Data de emissão",
          class: "w-full",
          color: "primary20",
          variant: "outlined",
          rules: [_unref(rules).required, _unref(rules).localeDate]
        }, null, 8, ["modelValue", "rules"]), [
          [_directive_maska, '##/##/####']
        ]),
        _withDirectives(_createVNode(_component_v_text_field, {
          modelValue: _unref(personalDataForm).cpf,
          "onUpdate:modelValue": [
            _cache[5] || (_cache[5] = ($event: any) => ((_unref(personalDataForm).cpf) = $event)),
            verifyCpf
          ],
          label: "* Cpf",
          class: "w-full",
          color: "primary20",
          variant: "outlined",
          rules: [_unref(rules).required, _unref(rules).cpf, _unref(validateCPF)],
          error: !!cpfIsValid.value,
          "error-messages": cpfIsValid.value
        }, null, 8, ["modelValue", "rules", "error", "error-messages"]), [
          [_directive_maska, '###.###.###-##']
        ]),
        _withDirectives(_createVNode(_component_v_text_field, {
          modelValue: _unref(personalDataForm).birthDate,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(personalDataForm).birthDate) = $event)),
          label: "* Data de Nascimento",
          class: "w-full",
          color: "primary20",
          variant: "outlined",
          rules: [_unref(rules).required, _unref(rules).birthday]
        }, null, 8, ["modelValue", "rules"]), [
          [_directive_maska, '##/##/####']
        ]),
        _createVNode(_component_v_text_field, {
          modelValue: _unref(personalDataForm).motherName,
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(personalDataForm).motherName) = $event)),
          label: "* Nome da mãe",
          class: "w-full",
          color: "primary20",
          variant: "outlined",
          rules: [_unref(rules).required]
        }, null, 8, ["modelValue", "rules"]),
        _createVNode(_component_v_text_field, {
          modelValue: _unref(personalDataForm).fatherName,
          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(personalDataForm).fatherName) = $event)),
          label: "* Nome do pai",
          class: "w-full",
          color: "primary20",
          variant: "outlined",
          rules: [_unref(rules).required]
        }, null, 8, ["modelValue", "rules"]),
        _createVNode(_component_v_autocomplete, {
          modelValue: _unref(personalDataForm).civilStates,
          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_unref(personalDataForm).civilStates) = $event)),
          label: "* Estado Civil",
          color: "primary",
          variant: "outlined",
          items: civilStates,
          rules: [_unref(rules).required]
        }, null, 8, ["modelValue", "rules"]),
        _createVNode(_component_v_text_field, {
          modelValue: _unref(personalDataForm).nationality,
          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_unref(personalDataForm).nationality) = $event)),
          label: "* Nacionalidade",
          class: "w-full",
          color: "primary20",
          variant: "outlined",
          rules: [_unref(rules).required]
        }, null, 8, ["modelValue", "rules"])
      ])
    ]),
    _: 1
  }, 512))
}
}

})